import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";
import { buttonVariants } from "@/components/flowly/infra/Button/Button";

interface NavCreateButtonProps {
  label: string;
  isLoggedIn?: boolean;
}

export function NavCreateButton({
  label,
  isLoggedIn = false,
}: NavCreateButtonProps) {
  // "צור עכשיו" צריך להוביל לסטודיו גם כשלא מחוברים; את דרישת ההרשמה נציג רק בפעולת יצירה.
  return (
    <Link
      to="/generate-product-catalog"
      className={cn(
        buttonVariants({ variant: "accent", size: "sm" }),
        "relative shadow-lg shadow-primary/40 hover:shadow-xl hover:shadow-primary/50 hover:scale-105 overflow-hidden"
      )}
      aria-label={label}
    >
      <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" />
      <Sparkles className="w-4 h-4" />
      {label}
    </Link>
  );
}
